const CCTVBox = ({ src }) => {
  const now = new Date().toLocaleString("ko-KR");

  return (
    <div className="relative bg-black rounded-lg overflow-hidden min-w-0 w-full">
      {/* REC */}
      <div className="absolute top-2 left-2 text-red-500 font-bold z-10 text-xs">
        ● REC
      </div>

      {/* 시간 */}
      <div className="absolute top-2 right-2 text-white z-10 text-xs truncate">
        {now}
      </div>

      {/* 이미지 */}
      <img
        src={src}
        alt="CCTV"
        className="w-full h-[200px] object-cover"
        style={{
          filter: "grayscale(20%) contrast(105%) brightness(85%)",
        }}
      />

      {/* 노이즈 */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "repeating-linear-gradient(transparent 0px, rgba(0,0,0,0.04) 2px, transparent 4px)",
        }}
      />
    </div>
  );
};

const Live = () => {
  // 각 CCTV마다 다른 이미지
  const img1 =
    "https://pds.joongang.co.kr/news/component/htmlphoto_mmdata/202308/23/831195e3-1e30-4d14-8f4c-43b3ed48e818.jpg";
  const img2 =
    "https://img4.yna.co.kr/etc/inner/KR/2021/06/07/AKR20210607093900052_01_i_P4.jpg";
  const img3 =
    "https://cdn.sisajournal.com/news/photo/202509/346642_352671_408.jpg";
  const img4 =
    "https://m.imaeil.com/photos/2025/08/31/2025083115470309148_l.jpg";

  return (
    <div
      className="mobile-page-root mb-16"
      style={{ width: '100%', maxWidth: '100vw', minWidth: 0, display: 'flex', justifyContent: 'center', overflowX: 'hidden', boxSizing: 'border-box' }}
    >
      <div
        className="mobile-page-root-inner space-y-3"
        style={{ width: '100%', maxWidth: '480px', margin: '0 auto', padding: '0 1rem 1rem', boxSizing: 'border-box', overflowX: 'hidden' }}
      >
        <div className="bg-white rounded-lg p-3 border min-w-0">
          <h2 className="text-lg font-bold text-gray-900 truncate">실시간 안전 관리</h2>
        </div>

        <div className="flex flex-col gap-2 min-w-0">
          <CCTVBox src={img1} />
          <CCTVBox src={img2} />
          <CCTVBox src={img3} />
          <CCTVBox src={img4} />
        </div>
      </div>
    </div>
  );
};

export default Live;
